import { MastheadLink, MastheadLinkOrLinkListArray } from 'lib/sanity/types';

export const isLinkVisible = (item: MastheadLink, isUserLoggedIn: boolean) => {
  if (item.displayOptions === undefined) {
    return true;
  }

  const option = isUserLoggedIn ? 'hideForLoggedIn' : 'hideForLoggedOut';

  return !item.displayOptions.includes(option);
};

export const isLinkDisabled = (item: MastheadLink, isUserLoggedIn: boolean) => {
  if (item.displayOptions === undefined) {
    return false;
  }

  const option = isUserLoggedIn ? 'disabledForLoggedIn' : 'disabledForLoggedOut';

  return item.displayOptions.includes(option);
};

export const getConsumerSecondaryLinks = (
  secondaryLinks: MastheadLinkOrLinkListArray | undefined,
  isConsumer: boolean,
  showPremiumDropdown: boolean,
) => {
  if (!secondaryLinks || !secondaryLinks.length) return [];
  if (!isConsumer) {
    return secondaryLinks;
  }

  const [explorePremiumLink, explorePremiumLinkList, ...rest] = secondaryLinks;

  if (showPremiumDropdown) {
    return [explorePremiumLinkList, ...rest];
  }
  return [explorePremiumLink, ...rest];
};
